import { SurchargeTranslationMapper } from "./surcharge-translation.mapper";
import { SurchargeType } from "./surcharge-type.model";
import { SurchargeTypeUpdaterMapper } from "./surcharge-type-updater/surcharge-type-updater.mapper";
import { SurchargeTypeUpdater } from "./surcharge-type-updater/surcharge-type-updater.model";

export class SurchargeTypeMapper {
  public static map(data: any): SurchargeType {
    if (!data) {
      return;
    }

    return new SurchargeType(
      data.id,
      data.name,
      data.ref,
      data.internalDescription,
      data.mandatory,
      data.uber,
      data.noMargin,
      data.internalComment,
      data.externalDescription,
      data.ltlSurchargeType,
      data.active,
      data.spot,
      data.applyInPtlQuotes,
      data.spotData
        ? SurchargeTypeUpdaterMapper.map(data.spotData)
        : new SurchargeTypeUpdater(0),
      data.translations && Array.isArray(data.translations)
        ? data.translations.map(SurchargeTranslationMapper.map)
        : [],
      data.incoterms && Array.isArray(data.incoterms) ? data.incoterms : [],
      data.selected ?? null,
      data.deleted ?? null,
      data.failedRestrictions ?? null,
    );
  }
}
